<template>
  <div class="wrapper">
    <AcceptCookies />
    <div
      v-if="$auth.ready()"
      id="default-body"
    >
      <Header style="background: white" />
      <slot />
      <div class="container p-0">
        <Footer />
        <Footer2 />
      </div>
    </div>
    <div v-if="!$auth.ready()">
      {{ $t('generic.loading', 'Loading') }}...
    </div>
    <ServerErrorNotif />
  </div>
</template>

<script>
import AcceptCookies from '@/components/AcceptCookies.vue';
import ServerErrorNotif from '@/components/ServerErrorNotif.vue';

import Header from '@/components/Home/Header';
import Footer from '@/components/jobs/Footer';
import Footer2 from '@/components/jobs/Footer2';

export default {
  name: 'Default',
  components: {
    AcceptCookies,
    ServerErrorNotif,
    Header,
    Footer,
    Footer2
  }
}
</script>

<style lang="scss">
body {
  width: 100%;
  margin: 0 !important;
}
#default-body {
  min-height: calc((100vh));
  background: #efefef;
}

.bg-home {
  background-image: url(../assets/home/hero.jpg);
  min-height: 375px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.search-comp {
  width: 60%;
  margin: 0 auto 75px auto;
  position: relative;
  top: 20%;
  text-align: left;
}

@media screen and (max-width: 1199px) {
  .search-comp {
    width: 100%;
    top: unset;
    padding-top: 50px;

    .search-card {
      margin: auto;
      width: 100%;
    }
  }
}
</style>
